import React, { useState, useMemo, useEffect } from 'react';
import { motion, AnimatePresence } from "framer-motion";
import { useScrollAnimation } from './hooks/ScrollAnimation';
import { rawPortfolioData } from '../data/portfolioData';
import { useTheme } from '../context/ThemeContext';

// Import Assets
import translateWeb from '../assets/Portofolio/translateWeb.png';
import squareGame from '../assets/Portofolio/GameSquarepng.png';
import squareGamePDF from '../assets/Portofolio/gameSquare.pdf';
import unityGame from '../assets/Portofolio/GameUnity#1.png';
import unityGameV from '../assets/Portofolio/gameUnity.mp4';
import landingPage from '../assets/Portofolio/landingpage.png';
import landingPagePDF from '../assets/Portofolio/landingpage.pdf';
import mvc from '../assets/Portofolio/mvc.png';
import pdfMVC from '../assets/Portofolio/mvc.pdf';
import layananMasyarakat from '../assets/Portofolio/layananmasyarakat.png';
import SanityImage from '../assets/Portofolio/Sanity.png';
import ThePill from '../assets/Portofolio/thePill.png';
import thePillVideo from '../assets/Portofolio/video/ThePillVideo.mp4';
import ADayWhenIWakeUp from '../assets/Portofolio/daywheniwakeup.png';
import aDayWhenIWakeUpVideo from '../assets/Portofolio/video/ADayWhenIWakeupPrototipe.mp4';
import wayoflight from '../assets/Portofolio/WayOfLight.png';
import wayoflightVideo from '../assets/Portofolio/video/ThirdGameplayVideo.mp4';
import gameWaifu from '../assets/Portofolio/showcaseGameWaifu.png';
import retlanUI from '../assets/Portofolio/retlanui.png';
import Homeland from '../assets/Portofolio/Homeland.png';
import HomelandVideo from '../assets/Portofolio/video/2025-11-25 15-30-47.mp4';
import GameDevBogorWebsite from '../assets/Portofolio/gdb.png';
import Khabits from '../assets/Portofolio/khabits.png';
import TIWebsite from '../assets/Portofolio/TIWebsite1.jpg';
import TIWebsitePort from '../assets/Portofolio/TIWebsite.pdf';
import OrangFinance from '../assets/Portofolio/orangfinance.png';
import Langflow from '../assets/Portofolio/video/langflow.mp4';
import langflow from '../assets/Portofolio/langflow.png';

// Sub-komponen agar setiap kartu punya observer scroll sendiri
const ProjectCard = ({ project, index, onViewProject, isDark }) => {
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.1 });
  const delay = (index % 2) * 100;

  const cardBg = isDark ? 'bg-[#0D1520]' : 'bg-white';
  const titleColor = isDark ? 'text-slate-100' : 'text-gray-800';
  const descColor = isDark ? 'text-slate-300' : 'text-gray-700';
  const techBg = isDark ? 'bg-[#111C2C] text-slate-300' : 'bg-gray-100 text-gray-800';
  const statusBg = isDark ? 'bg-[#0D1520] text-slate-200' : 'bg-white';

  return (
    <motion.div
      ref={ref}
      key={project.id}
      layout
      className={`${cardBg} pixel-border overflow-hidden hover:shadow-lg transition-all flex flex-col h-full`}
      style={{
        transitionDelay: `${delay}ms`,
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? 'translateY(0)' : 'translateY(32px)',
        transition: 'opacity 0.6s ease-out, transform 0.6s ease-out',
      }}
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.9 }}
      transition={{ duration: 0.3 }}
    >
      <div className="h-40 sm:h-48 bg-gray-200 overflow-hidden relative flex-shrink-0">
        <img src={project.image} alt={project.title} className="w-full h-full object-cover" />
        <div className={`absolute top-2 right-2 px-2 py-1 text-[10px] md:text-xs pixel-border ${statusBg} font-bold`}>
          {project.status}
        </div>
        <div className="absolute top-2 left-2 px-2 py-1 text-[10px] md:text-xs pixel-border bg-blue-600 text-white font-bold uppercase">
          {project.type}
        </div>
      </div>

      <div className="p-4 md:p-5 flex flex-col flex-grow">
        <h3 className={`text-lg md:text-xl font-bold ${titleColor} mb-2`}>{project.title}</h3>
        <div className={`${descColor} mb-6 text-sm md:text-base leading-relaxed`}>
          {project.description}
        </div>

        <div className="mt-auto">
          <div className="flex flex-wrap gap-1 md:gap-2 mb-4">
            {project.technologies.map((tech, techIndex) => (
              <span
                key={techIndex}
                className={`px-2 py-1 ${techBg} text-[10px] md:text-xs pixel-border`}
              >
                {tech}
              </span>
            ))}
          </div>

          <button
            className="w-full pixel-button bg-blue-600 text-white py-2 text-xs md:text-sm hover:bg-blue-700"
            onClick={() => onViewProject(project)}
          >
            LIHAT PROJECT
          </button>
        </div>
      </div>
    </motion.div>
  );
};

const Portfolio = () => {
  const { isDark } = useTheme();
  const [visibleCount, setVisibleCount] = useState(4);
  const [showAll, setShowAll] = useState(false);
  const [popupMedia, setPopupMedia] = useState(null);
  const [activeFilter, setActiveFilter] = useState("all");

  const { ref: titleRef, isVisible: titleVisible } = useScrollAnimation({ threshold: 0.1 });
  const { ref: filterRef, isVisible: filterVisible } = useScrollAnimation({ threshold: 0.1 });
  const { ref: paginationRef, isVisible: paginationVisible } = useScrollAnimation({ threshold: 0.1 });

  const projectAssets = [
    { image: wayoflight,       technologies: ["Unity", "C#", "Team Leader", "Game Design"],                    media: { type: "video", src: wayoflightVideo } },
    { image: ADayWhenIWakeUp,  technologies: ["Unity", "C#", "Team Leader", "Game Design"],                    media: { type: "video", src: aDayWhenIWakeUpVideo }, description: (<>Game ini bergenre platformer naratif 2D. Saya adalah pemimpin proyek, yang juga bertanggung jawab atas desain dan pemrograman game. Game ini menceritakan kisah seseorang yang terbangun sebagai seekor burung dan menjelajahi dunia untuk menemukan apa yang sebenarnya terjadi. Project ini tidak pernah selesai karena masalah internal tim, yang menyebabkan penundaan project, dan akhirnya hanya menghasilkan prototype saja. Namun, saya telah menyelesaikan ceritanya, bisa dibaca <a href="https://medium.com/@nakhalanatqiya/rebirth-39fe50401c66" target="_blank" rel="noopener noreferrer" className="text-blue-400 underline hover:text-blue-300">disini</a>.</>) },
    { image: ThePill,          technologies: ["Unity", "C#", "Team Leader", "Game Design"],                    media: { type: "video", src: thePillVideo } },
    { image: SanityImage,      technologies: ["Unity", "C#", "Team Leader", "Game Design"],                    link: "https://globalgamejam.org/games/2025/sanity-2" },
    { image: layananMasyarakat,technologies: ["Javascript", "MySQL", "React", "Express.jss"],                  link: "https://github.com/NakhalanAtqiyaAP/Pengaduan_App" },
    { image: mvc,              technologies: ["PHP", "MySQL", "MVC", "CRUD", "Responsive"],                    media: { type: "pdf", src: pdfMVC } },
    { image: landingPage,      technologies: ["HTML", "CSS", "JavaScript", "Responsive"],                      media: { type: "pdf", src: landingPagePDF } },
    { image: unityGame,        technologies: ["Unity", "C#", "2D Game", "UI Design"],                          media: { type: "video", src: unityGameV } },
    { image: squareGame,       technologies: ["JavaScript", "PHP Native", "MYSQL"],                            media: { type: "pdf", src: squareGamePDF } },
    { image: translateWeb,     technologies: ["Html", "CSS", "JavaScript", "API"],                             link: "https://translatewebsiteindotoingg.netlify.app/" },
    { image: gameWaifu,        technologies: ["React", "Tailwind"],                                            link: "https://typing-game-with-gf.netlify.app/" },
    { image: retlanUI,         technologies: ["Liblary Tailwind"],                                             link: "https://retlan-ui-website.vercel.app/" },
    { image: Homeland,         technologies: ["Unity", "C#", "3D Game", "UI Design", "Writer"],                media: { type: "video", src: HomelandVideo } },
    { image: GameDevBogorWebsite, technologies: ["Liblary Tailwind", "RetlanUI", "React"],                     link: "https://gamedevbogor.vercel.app/" },
    { image: Khabits,          technologies: ["Liblary Tailwind", "RetlanUI", "React"],                        link: "https://khabits.vercel.app/" },
    { image: TIWebsite,        technologies: ["Liblary Tailwind", "RetlanUI", "React", "Supabase"],            media: { type: "pdf", src: TIWebsitePort } },
    { image: OrangFinance,     technologies: ["Liblary Tailwind", "RetlanUI", "React", "Supabase"],            link: "https://orangfinance.vercel.app/" },
    { image: langflow,         technologies: ["AI Agent", "AI", "Langflow", "IBM"],                            media: { type: "video", src: Langflow } },
  ];

  const descriptionMap = {
    1:  "Game ini bergenre hack and slash, naratif, dan RPG 3D. Saya adalah pemimpin project, programmer, dan desainer game. Game ini bertema supernatural yang bertujuan untuk menampilkan setan-setan Indonesia. Kami telah mengembangkan berbagai konsep, termasuk konsep cerita dan karakter. Namun, selama proses produksi, ternyata cakupan game RPG terlalu luas, sehingga kami akhirnya menghentikan game tersebut dan menjadikannya sebagai prototype.",
    3:  "Game ini bergenre naratif horor 3D. Saya adalah pemimpin project ini, sekaligus bertanggung jawab atas desain dan pemrograman game. Meskipun game ini belum beres karena ada masalah internal, saya berhasil membuat prototipe yang memuaskan.",
    4:  "Game ini adalah game pertama saya setelah berpartisipasi dalam sebuah Game Jam dan game pertama yang saya publikasikan. Game ini terinspirasi dari Doom, di mana pemain harus menembak musuh tetapi juga memperhatikan bar pernapasan player, yang berkurang seiring berjalannya game. Oleh karena itu, pemain harus menemukan tempat untuk mengisinya kembali. Karena game ini berlatar di bawah air, pemain harus menemukan jalan keluar sambil menghabisi monster. Proyek ini dibuat bersama tim selama acara Global Game Jam 2025. Saya berperan sebagai game design sekaligus game programmer.",
    5:  "Saya membuat website ini menggunakan express.js dan react.js untuk menyediakan layanan pengaduan publik di berbagai provinsi di Indonesia. website ini memiliki tiga peran: admin, staf, dan pengunjung atau pelapor. Website ini juga terhubung ke database MySQL.",
    6:  "Website ini memiliki berbagai fitur, yaitu menambah, mengedit, dan menghapus data. website ini dibangun dengan konsep MVC menggunakan PHP dan MySQL sebagai database.",
    7:  "Saya mengembangkan website ini mengimplementasikan apa yang saya pelajari tentang responsive website. Website ini dibuat dengan HTML, CSS, dan JavaScript.",
    8:  "Sebenarnya, game yang saya buat di Unity belum sepenuhnya selesai dan hanya berakhir menjadi sebuah prototype. Jadi, konsep gamenya adalah pemain melompat dan menghadapi berbagai rintangan.",
    9:  "Ini adalah pencapaian terbesar saya saat coding menggunakan Java script dan PHP, di website ini terdapat dua jenis game yaitu Snakegame dan SquareGame (game fighting)",
    10: "Saya membuat website ini saat sedang mempelajari tentang API. Jadi, situs ini menggunakan API translate dari mymemory translate. Di website ini, Kamu bisa menerjemahkan dari Bahasa Indonesia ke Bahasa Inggris atau sebaliknya.",
    11: "Saya terinspirasi dari website monkeytype, dimana ternyata sangat seru untuk mengetik terlebih lagi untuk mengejar ketikan sampai waktu yang dibatasi. Game ini mengusung tema pacaran, yaa sedikit simulasi percintaan. POV ketika pacar mu lagi ngambek kamu harus balas chat dia secepat kilat! wkwkwk.",
    12: "Saya sangat menyukai bagaimana design di website personal ini menjadi identitas website personal saya. Karena itu saya membuat sebuah liblary dimana orang-orang bisa menggunakan atau membuat design component-component seperti yang ada diwebsite personal ini. Saya membuat project ini menggunakan sistem css dimana nanti css tersebut bisa di download lewat NPM. Project ini masih pada tahap pengembangan dan bersifat open source jadi pantengin saja terus. Jika berminat bisa klik `Lihat Project` disana ada cara install dan dokumentasinya.",
    13: "Homeland adalah game eksperimen dari saya, dengan memadukan genre shooter, sci-fi dan silent. Disini saya mengambil tema alternatif timeline dimana Belanda tak meninggalkan Indonesia sebagai tanah jajahannya, karena Belanda menemukan material yang kuat di Indonesia. Saya terinspirasi dari beberapa game seperti Wolfstein, Fallout dan Far Cry. Project game ini masih saya kerjakan dan butuh waktu lama untuk develop nya, jadi stay tune saja!",
    14: "Dalam project ini saya diberi kesempatan untuk debut khusus RetlanUI, saya sangat bangga sekali akan pencapai yang RetlanUI capai untuk bisa debut dalam pengembangan website Game Developer Bogor. Disini saya menjadi front-end untuk membuat tampilan website dengan menggunakan liblary RetlanUI.",
    15: "Saya sedang membaca buku Atomic Habits, telah membawa sebuah kesadaran yang membuat saya lebih memaknai segala hal yang ada di sekitar saya, apa yang saya lakukan, dan hal-hal kecil yang ternyata indah jika kita merangkulnya dalam hidup kita. Dalam buku ini, saya diajarkan untuk menikmati proses tanpa perlu terpaku pada hasil di akhir. Ini membawa saya pada kesadaran spiritual saya sendiri, bahwa jika kita gagal tidak apa-apa karena itu juga bagian dari diri kita yang membentuk kita untuk menjadi lebih baik lagi dan itu memang siklus kehidupan ini. Dengan menggunakan React + Tailwind + RetlanUI + Firebase untuk membangun website ini. Dan hal yang paling saya suka di website ini adalah tracker rutinitas secara realtime, kita bisa memantau aktivitas apa yang baik dan buruk untuk kita untuk menjadi lebih baik setidaknya 1% setiap hari. Saya mengejar konsiten dan sebisa mungkin tidak menghabiskan energi saya untuk mengejar ekspetasi untuk hasil yang belum tentu. Dengan website ini saya bisa untuk memantau keseharian saya dan dalam penuh sadar saya hidup disini disaat ini.",
    16: "Saya membuat sebuah sistem manajemen tugas untuk mahasiswa di kelas kampus saya. Di mana saya membuatnya menggunakan React + Supabase + RetLan UI. Ini adalah perdana saya mencoba memakai Supabase, dan saya sangat menyukai bagaimana Supabase memberikan pelayanan yang penuh, maksimal, dan gratis. Tentu saja untuk project kecil seperti ini Supabase cocok sekali digunakan. Di project ini saya menjadi fullstack dan membuat project dari nol sendirian. Dengan project ini saya ingin membantu dan menjadi berguna untuk teman-teman saya dalam kelas yang kami tempuh bersama untuk bisa mengerjakan tugas lebih efektif lagi.",
    17: "Ya! kali ini saya bikin project untuk finance tracker. Perkenalkan, OrangFinance adalah sebuah website untuk tracking keuangan kita. Saya membangun proyek ini dari masalah saya sehari-hari. Rasanya uang bulanan yang dikumpulkan kok tiba-tiba terkuras abis gitu aja. Saya sadar saya mengeluarkan uang untuk apa, tapi dengan ketidaktertransparansi terhadap diri sendiri, dengan mencatat keuangan pribadi, pengeluaran saya menjadi jauh lebih boros daripada yang saya inginkan. Oleh karenanya, saya alih-alih mencatat keuangan di buku, saya membuat website ini sekaligus ingin tahu statistik yang dihasilkannya juga. Saya membangun website ini menggunakan React, tailwind, supabase dan RetlanUI, ini pertama kalinya saya membangun project tentang keuangan, cukup menantang ketika harus membangun statistik yang benar-benar sesuai. Hasilnya, saya cukup puas dan saya rasa bisa lebih dikembangkan menjadi lebih kompleks lagi.",
    18: "Dari kelas yang saya ikuti dari program Hacktiv8 x IBM SkillsBuild. Saya belajar banyak hal tentang AI, mulai dari belajar untuk vibe coding dengan benar hingga membuat AI agent sendiri menggunakan model AI seperti Gemini. Setelah melihat dan merasakan dapur AI, saya merasa Ini merupakan sebuah pengalaman yang luar biasa, karena ternyata AI sepowerfull itu untuk mengendalikan sebuah data dan dengan apa yang saya pelajari dari ini saya merasakan banyak potensi projek yang bisa saya kembangkan. Untuk projek latihan dibawah, saya membuat konsep Customer Service untuk toko buku berbasis AI, dimana AI bisa memberikan rekomendasi personal bagi customer yang ingin mencari buku. Dengan menggunakan Langflow dan AI model Gemini untuk membuat flow AI nya.",
  };

  const projects = useMemo(() => rawPortfolioData.map((p, i) => ({
    ...p,
    ...projectAssets[i],
    description: projectAssets[i]?.description ?? descriptionMap[p.id] ?? '',
  })), []);

  const types = ["all", ...new Set(projects.map(project => project.type))];

  const filteredProjects = useMemo(() => {
    let result = [...projects].sort((a, b) => b.id - a.id);
    if (activeFilter !== "all") {
      result = result.filter(project => project.type === activeFilter);
    }
    return result;
  }, [projects, activeFilter]);

  const loadMore = () => {
    setVisibleCount(filteredProjects.length);
    setShowAll(true);
  };

  const showLess = () => {
    setVisibleCount(4);
    setShowAll(false);
  };

  const handleViewProject = (project) => {
    if (project.link) {
      window.open(project.link, "_blank");
    } else if (project.media) {
      setPopupMedia(project.media);
    }
  };

  useEffect(() => {
    setVisibleCount(4);
    setShowAll(false);
  }, [activeFilter]);

  const titleColor = isDark ? 'text-white' : 'text-gray-800';
  const subtitleColor = isDark ? 'text-slate-400' : 'text-gray-600';
  const filterActiveBg = 'bg-blue-600 text-white';
  const filterInactiveBg = isDark
    ? 'bg-[#111C2C] text-slate-300 hover:bg-[#1E3A5F]'
    : 'bg-gray-100 text-gray-800 hover:bg-gray-200';
  const emptyText = isDark ? 'text-slate-500' : 'text-gray-600';

  return (
    <section id="portfolio" className={`py-8 md:py-12 px-4 ${isDark ? 'bg-[#0D1520]' : 'bg-gray-50'}`}>
      <div className="container mx-auto max-w-6xl">

        {/* Judul & Deskripsi */}
        <div
          ref={titleRef}
          className="text-center mb-8 md:mb-12"
          style={{
            opacity: titleVisible ? 1 : 0,
            transform: titleVisible ? 'translateY(0)' : 'translateY(-24px)',
            transition: 'opacity 0.6s ease-out, transform 0.6s ease-out',
          }}
        >
          <h2 className={`text-xl md:text-2xl lg:text-3xl font-bold ${titleColor} mb-2 pixel-font`}>
            <span className="glitch-text" data-text="PORTOFOLIO">PORTOFOLIO</span>
          </h2>
          <p className={`${subtitleColor} text-sm md:text-base`}>
            Lihat berbagai project yang pernah saya buat ({filteredProjects.length})
          </p>
        </div>

        {/* Filter Buttons */}
        <div
          ref={filterRef}
          className="flex flex-wrap justify-center gap-2 mb-6 md:mb-8"
          style={{
            opacity: filterVisible ? 1 : 0,
            transform: filterVisible ? 'translateY(0)' : 'translateY(16px)',
            transition: 'opacity 0.5s ease-out 0.1s, transform 0.5s ease-out 0.1s',
          }}
        >
          {types.map((type, index) => (
            <motion.button
              key={index}
              className={`px-4 py-2 text-sm md:text-base pixel-border ${
                activeFilter === type ? filterActiveBg : filterInactiveBg
              }`}
              onClick={() => setActiveFilter(type)}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              {type.charAt(0).toUpperCase() + type.slice(1)}
            </motion.button>
          ))}
        </div>

        {/* Project Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-6">
          <AnimatePresence mode='popLayout'>
            {filteredProjects.slice(0, visibleCount).map((project, index) => (
              <ProjectCard
                key={project.id}
                project={project}
                index={index}
                onViewProject={handleViewProject}
                isDark={isDark}
              />
            ))}
          </AnimatePresence>
        </div>

        {/* Pagination Buttons */}
        {filteredProjects.length > 4 && (
          <div
            ref={paginationRef}
            className="text-center mt-12"
            style={{
              opacity: paginationVisible ? 1 : 0,
              transform: paginationVisible ? 'translateY(0)' : 'translateY(16px)',
              transition: 'opacity 0.5s ease-out 0.2s, transform 0.5s ease-out 0.2s',
            }}
          >
            {!showAll ? (
              <motion.button
                className="pixel-button bg-blue-600 text-white py-2 px-6 hover:bg-blue-700"
                onClick={loadMore}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                LOAD MORE ({filteredProjects.length - visibleCount} MORE)
              </motion.button>
            ) : (
              <motion.button
                className={`pixel-button py-2 px-6 ${isDark ? 'bg-[#111C2C] text-slate-300 hover:bg-[#1E3A5F]' : 'bg-gray-600 text-white hover:bg-gray-700'}`}
                onClick={showLess}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                SHOW LESS
              </motion.button>
            )}
          </div>
        )}

        {filteredProjects.length === 0 && (
          <div className="text-center py-12">
            <p className={`${emptyText} pixel-font`}>Project tidak ditemukan.</p>
          </div>
        )}
      </div>

      {/* Popup Modal */}
      <AnimatePresence>
        {popupMedia && (
          <motion.div
            className="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-[999] p-4"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setPopupMedia(null)}
          >
            <motion.div
              className={`relative max-w-5xl w-full pixel-border overflow-hidden ${isDark ? 'bg-[#0D1520]' : 'bg-white'}`}
              initial={{ scale: 0.9, opacity: 0, y: 50 }}
              animate={{ scale: 1, opacity: 1, y: 0 }}
              exit={{ scale: 0.9, opacity: 0, y: 50 }}
              onClick={(e) => e.stopPropagation()}
            >
              <button
                className="absolute top-2 right-2 bg-red-600 text-white w-8 h-8 flex items-center justify-center pixel-border z-50 font-bold"
                onClick={() => setPopupMedia(null)}
              >
                X
              </button>

              <div className="w-full h-[70vh] md:h-[80vh] bg-black flex items-center justify-center">
                {popupMedia.type === "pdf" && (
                  <iframe
                    src={popupMedia.src}
                    title="PDF Preview"
                    className="w-full h-full border-none"
                  ></iframe>
                )}
                {popupMedia.type === "video" && (
                  <video
                    src={popupMedia.src}
                    controls
                    autoPlay
                    className="max-w-full max-h-full"
                    onAbort={() => console.log("Video Playback Interrupted")}
                  />
                )}
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
};

export default Portfolio;
